import {type IAsset} from '@netx/core-asset-next/schema';
import {isMobile} from '@netx/core-utils';
import {assetProjectEnabled} from './assetProjectEnabled';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';

export const canCreateAssetProject = (asset?: IAsset) => {
	if (isMobile(false)) return false;
	if (!asset) return false;
	if (!asset.fileFormatFamily.includes('image')) return false;
	if (!assetProjectEnabled()) return false;

	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.READ,
		permissionName: PermissionName.CREATE_REVIEWS,
	});
};
